import { Injectable, NgModule } from '@angular/core';
import { CustomCurrencyPipe } from './custom-currency.pipe';
import { Day_diffPipe } from './day_diff.pipe';
import { CommonModule } from '@angular/common';
import { FetchTimePipe } from './fetchTime.pipe';
import { FilterPipe } from './filter.pipe';

@Injectable({
  providedIn: 'root'
})
@NgModule({
  declarations: [CustomCurrencyPipe, Day_diffPipe, FetchTimePipe, FilterPipe],
  imports: [CommonModule],
  exports: [CustomCurrencyPipe, Day_diffPipe, FetchTimePipe, FilterPipe]
})
export class PipesModule {}
